import { z } from 'zod';

export const createLoginSchema = () =>
  z.object({
    username: z
      .string()
      .min(1, 'username cannot be empty')
      .refine((value) => /[A-Za-z]/.test(value), {
        message: 'username must contain at least one alphabetic character',
      }),

    password: z.string().min(1, 'password cannot be empty').min(6, 'Minimum 6 characters required'),

    captchaText: z.string().min(1, 'Validation cannot be empty'),

    rememberMe: z.boolean().optional(),
  });

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
